export default __webpack_public_path__ + "static/media/dashboard.c12a24ec.svg";